{
  "name": "entai-admin-cdn",
  "version": "3.579.0",
  "description": "KnowledgeBase admin UI with API integration and Analytics Logging",
  "main": "index.js",
  "scripts": {
    "prepare": "husky install",
    "format": "eslint --fix .",
    "eslint": "eslint --ext .js .",
    "eslint:fix": "npm run eslint -- --fix",
    "preanalyze": "node scripts/esbuild.js --analyze",
    "analyze": "esbuild-visualizer --metadata ./meta.json && open stats.html",
    "build:src": "node scripts/esbuild.js",
    "build:lang": "node scripts/lang-build.js",
    "build--pre": "rm -rf build dist; mkdir -p build dist",
    "build--pre:https-dev": "rm -rf build https-dev; mkdir -p build https-dev",
    "build--pre:https-localhost": "rm -rf build https-localhost; mkdir -p build https-localhost",
    "build": "npm-run-all eslint build--pre -p build:* --aggregate-output",
    "build--watch": "npm-run-all build--pre -p \"build:* -- --watch\"",
    "build--watch:https-dev": "npm-run-all build--pre:https-dev -p \"build:* -- --watch\"",
    "build--watch:https-localhost": "npm-run-all build--pre:https-localhost -p \"build:* -- --watch\"",
    "start": "NODE_ENV=dev npm-run-all -p build--watch serve",
    "start:localhost": "NODE_ENV=dev APP_API_DOMAIN=http://localhost:8080 npm-run-all -p build--watch serve",
    "prestart:https-dev": "bash scripts/ensure-https.sh",
    "prestart:https-localhost": "bash scripts/ensure-https.sh",
    "start:https-dev": "NODE_ENV=dev HTTPS=1 DIST_DIR=./https-dev APP_HOST=localhost.adobe.com APP_PORT=3000 APP_API_DOMAIN=https://yukon-dev.adobe.io npm-run-all -p build--watch:https-dev serve:https-dev",
    "start:https-localhost": "NODE_ENV=dev HTTPS=1 DIST_DIR=./https-localhost APP_HOST=localhost.adobe.com APP_PORT=9000 APP_API_DOMAIN=https://localhost:9443 npm-run-all -p build--watch:https-localhost serve:https-localhost",
    "serve": "esbuild --serve --servedir=dist",
    "serve:https-dev": "http-server https-dev/ -p 3000 -S -a localhost.adobe.com",
    "serve:https-localhost": "http-server https-localhost/ -p 9000 -S -a localhost.adobe.com",
    "test": "jest --no-cache --noStackTrace",
    "test:dev": "jest --no-cache --watch",
    "test:dev-debug": "DEBUG=nock.scope:* jest --no-cache --watch --noStackTrace",
    "test:coverage": "rm -rf coverage && NODE_OPTIONS='--max-old-space-size=9216' node --no-compilation-cache node_modules/.bin/jest --no-cache --coverage --workerIdleMemoryLimit=4GiB && echo 'open coverage/lcov-report/index.html'",
    "test:sonar": "NODE_PATH=./src node run-sonar.js",
    "postinstall": "echo 'nothing to do for postinstall'",
    "auto-increment-version": "auto-increment-version",
    "_check-for-onlys": "! GREP_COLOR='1;35;40' egrep --color=always '(\\.only\\b|\\bfit\\s*\\(|\\bfdescribe\\b)'",
    "_check-locale-branch-src": "test `git rev-parse --abbrev-ref HEAD` != 'loc-team' || (./node_modules/.bin/boxen --margin 1 --padding 2 --border-color red \"⚠️  Changes to src/ cannot be committed to loc-team branch.\"; false) #",
    "_check-locale-branch": "test `git rev-parse --abbrev-ref HEAD` = 'loc-team' || (./node_modules/.bin/boxen --margin 1 --padding 2 --border-color red \"⚠️  Changes to src/nls/en-US.json\\n can only be committed to loc-team branch.\"; false) #",
    "validate:locale-integrity": "find src/nls -type f -name \\*.json | while read f; do echo \"$f\"; json-diff -k src/nls/ui-strings/en-US.json $f; echo; done;",
    "validate:translations": "(! grep -r --exclude zz-ZZ.json ': \"\\[' src/translations) && echo No missing translations ✔️;"
  },
  "repository": {
    "type": "git",
    "url": "https://git.corp.adobe.com/EchoSign/entai-admin-cdn.git"
  },
  "author": "",
  "license": "ISC",
  "versions": {
    "signprovider": "3.1.3_8.3.0"
  },
  "devDependencies": {
    "@a4u/a4u-s2-acrobat-dc": "5.1.0",
    "@adobesign/as-dev-tools": "1.3.1",
    "@babel/core": "^7.26.10",
    "@babel/eslint-parser": "^7.26.10",
    "@babel/preset-env": "^7.26.0",
    "@babel/preset-react": "^7.26.3",
    "@dc.tools/eslint-config": "^3.9.0",
    "@eslint/compat": "^1.2.4",
    "@eslint/eslintrc": "^3.2.0",
    "@eslint/js": "^9.17.0",
    "@react-spectrum/toast": "^3.0.0-beta.17",
    "@testing-library/dom": "^10.4.0",
    "@testing-library/jest-dom": "^6.6.3",
    "@testing-library/react": "^16.1.0",
    "@testing-library/user-event": "^14.5.2",
    "babel-jest": "^29.7.0",
    "babel-polyfill": "~6.26.0",
    "baseline-browser-mapping": "^2.9.11",
    "boxen-cli": "^4.0.0",
    "chai": "~5.1.2",
    "enzyme": "^3.11.0",
    "enzyme-adapter-react-16": "^1.15.8",
    "esbuild": "^0.25.2",
    "esbuild-css-modules-plugin": "^3.1.2",
    "esbuild-node-externals": "^1.16.0",
    "esbuild-plugin-alias": "^0.2.1",
    "esbuild-plugin-import-glob": "^0.1.1",
    "esbuild-plugin-svgr": "^3.1.0",
    "esbuild-visualizer": "^0.6.0",
    "eslint": "^9.22.0",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-import": "^2.31.0",
    "eslint-plugin-notice": "^1.0.0",
    "eslint-plugin-prettier": "^5.2.1",
    "fs-extra": "^11.2.0",
    "glob": "^11.1.0",
    "http-server": "^14.1.1",
    "husky": "^9.1.7",
    "identity-obj-proxy": "^3.0.0",
    "jest": "^30.2.0",
    "jest-environment-jsdom": "^29.7.0",
    "jest-transform-stub": "^2.0.0",
    "jest-transformer-svg": "^2.0.2",
    "json-diff": "^1.0.6",
    "lightningcss": "^1.28.0",
    "lint-staged": "^15.2.11",
    "nock": "^13.5.6",
    "node-fetch": "^2.6.6",
    "npm-run-all": "^4.1.5",
    "path": "^0.12.7",
    "prettier": "^3.4.2",
    "semver": "^7.7.3",
    "sonarqube-scanner": "^4.3.2",
    "unplugin": "^1.16.0",
    "unplugin-parcel-macros": "^0.1.1"
  },
  "dependencies": {
    "@adobe/react-spectrum": "^3.45.0",
    "@dcloud/dc-view-sdk-bundle": "3.56.0",
    "@e965/xlsx": "0.20.3",
    "@emotion/react": "^11.13.3",
    "@emotion/styled": "^11.14.1",
    "@fortune-sheet/react": "^1.0.4",
    "@googleworkspace/drive-picker-element": "^0.7.3",
    "@identity/imslib": "^0.53.0",
    "@internationalized/date": "^3.8.2",
    "@microlink/react-json-view": "^1.26.1",
    "@microsoft/fetch-event-source": "^2.0.1",
    "@mui/joy": "^5.0.0-beta.52",
    "@mui/material": "^7.3.4",
    "@nivo/bar": "^0.99.0",
    "@nivo/core": "^0.99.0",
    "@nivo/line": "^0.99.0",
    "@nivo/pie": "^0.99.0",
    "@nivo/radar": "^0.99.0",
    "@nivo/tooltip": "^0.99.0",
    "@nivo/treemap": "^0.99.0",
    "@react-spectrum/ai": "0.5.2",
    "@react-spectrum/autocomplete": "^3.0.0-alpha.38",
    "@react-spectrum/dropzone": "3.0.6",
    "@react-spectrum/s2": "^1.6.0",
    "@react-spectrum/tag": "^3.2.11",
    "@spectrum-icons/express": "^3.0.0-alpha.21",
    "@spectrum-icons/illustrations": "^3.6.24",
    "@spectrum-icons/ui": "^3.6.11",
    "@spectrum-icons/workflow": "^4.2.16",
    "@xyflow/react": "^12.4.2",
    "ajv": "^8.20.0",
    "axios": "^1.20.0",
    "axios-cache-interceptor": "^1.11.3",
    "copy-to-clipboard": "^3.3.3",
    "cross-spawn": "^7.0.6",
    "d3": "^7.9.0",
    "d3-format": "^3.1.0",
    "d3-scale": "^4.0.2",
    "d3-scale-chromatic": "^3.1.0",
    "dc-icons": "^2.105.0",
    "dc-preview-utils": "^2.2.31",
    "dompurify": "^3.4.17",
    "es6-promise": "~4.2.8",
    "framer-motion": "^12.23.24",
    "gapi-script": "^1.2.0",
    "googleapis": "^188.0.0",
    "hast-util-sanitize": "^5.0.2",
    "joi": "^17.13.8",
    "lodash": "^4.18.0",
    "lodash.debounce": "^4.0.8",
    "mime": "^4.0.7",
    "moment": "^2.31.0",
    "prismjs": "^1.30.0",
    "process": "^0.11.10",
    "prop-types": "^15.8.1",
    "react": "^18.3.1",
    "react-aria": "^3.36.0",
    "react-diff-viewer": "^3.1.1",
    "react-dom": "^18.3.1",
    "react-intl": "^7.0.4",
    "react-joyride": "^3.2.0",
    "react-json-view-lite": "^2.5.0",
    "react-konva": "^19.0.2",
    "react-markdown": "^9.0.1",
    "react-mitt": "^1.0.1",
    "react-rnd": "^10.4.13",
    "react-router-dom": "^7.18.4",
    "react-stately": "^3.34.0",
    "react-swipeable-views": "^0.14.0",
    "react-syntax-highlighter": "^15.6.6",
    "recharts": "^2.13.3",
    "rehype-katex": "^7.0.1",
    "rehype-raw": "^7.0.0",
    "rehype-sanitize": "^6.0.0",
    "remark-gfm": "^4.0.0",
    "remark-math": "^6.0.0",
    "styled-components": "^6.6.0",
    "ua-parser-js": "^1.0.40",
    "uuid": "^11.0.3"
  },
  "jest": {
    "setupFilesAfterEnv": [
      "<rootDir>/src/setupTests.js"
    ],
    "testEnvironment": "jest-environment-jsdom",
    "testPathIgnorePatterns": [
      "/node_modules/",
      "<rootDir>/dist/"
    ],
    "transform": {
      "\\.[jt]sx?$": "babel-jest",
      "^.+\\.cjs$": "babel-jest",
      ".+\\.(png|jpg|ttf|woff|woff2|csv)$": "jest-transform-stub",
      "^.+\\.(svg)$": "jest-transformer-svg"
    },
    "moduleNameMapper": {
      "\\.(css|scss)$": "identity-obj-proxy",
      "translations/\\*\\.json": "<rootDir>/__mocks__/translations-glob.js",
      "^@react-spectrum/s2/icons/Circle$": "<rootDir>/node_modules/@react-spectrum/s2/icons/Circle.cjs"
    },
    "transformIgnorePatterns": [
      "<rootDir>/node_modules/(?!(axios|@identity/imslib|dc-sign-provider|dc-icons|react-router-dom|node-fetch|react-markdown|remark-.*|rehype-.*|unified|unist-.*|mdast-.*|micromark.*|hast-.*|vfile.*|bail|trough|is-plain-obj|property-information|space-separated-tokens|comma-separated-tokens|estree-util-is-identifier-name|html-url-attributes|devlop|decode-named-character-reference|character-entities.*|zwitch|ccount|escape-string-regexp|markdown-table|longest-streak|stringify-entities|trim-lines|web-namespaces|html-void-elements|mime)/)"
    ],
    "collectCoverageFrom": [
      "src/**/*.js"
    ]
  },
  "lint-staged": {
    "src/**/*.{js,css,scss,md}": [
      "npm run --silent _check-locale-branch-src",
      "prettier --write"
    ],
    "src/**/translations/en-US.json": [
      "npm run --silent _check-locale-branch"
    ],
    "src/**/*.test.js": [
      "npm run --silent _check-for-onlys"
    ]
  },
  "prettier": {
    "tabWidth": 2,
    "printWidth": 100,
    "useTabs": false,
    "semi": true,
    "singleQuote": true,
    "bracketSpacing": true,
    "filepath": "./src"
  },
  "overrides": {
    "@react-spectrum/ai": {
      "@react-spectrum/s2": "$@react-spectrum/s2",
      "react-aria": "$react-aria",
      "react-stately": "$react-stately",
      "react-aria-components": "1.20.0",
      "@react-types/shared": "3.36.1",
      "@internationalized/date": "$@internationalized/date",
      "@internationalized/number": "3.6.7"
    }
  }
}
